import firebase from 'firebase';

const mangaafirebaseConfig = {
  apiKey: "AIzaSyCKx4FYfA_GMlRXuW78Ge2TSwOOuMd2Gjk",
  authDomain: "mangaa-40c35.firebaseapp.com",
  databaseURL: "https://mangaa-40c35.firebaseio.com",
  projectId: "mangaa-40c35",
  storageBucket: "mangaa-40c35.appspot.com",
  messagingSenderId: "76247418256",
  appId: "1:76247418256:web:e2b9807ee5f174962c9f15",
  measurementId: "G-HFL6SHCT7V"
};

const famdyfirebaseConfig = {
  apiKey: "AIzaSyBFnuOLPH5BwbdiIut6hl4DBjjSyP5Y5ss",
  authDomain: "famdy-96e74.firebaseapp.com",
  projectId: "famdy-96e74",
  storageBucket: "famdy-96e74.appspot.com",
  messagingSenderId: "417630390686",
  appId: "1:417630390686:web:326e8bf9bca6c790646e8f",
  measurementId: "G-GLQ0PYNKTW"
};

var mangaa = firebase.initializeApp(mangaafirebaseConfig);
var famdy = firebase.initializeApp(famdyfirebaseConfig, 'other');

export const auth = mangaa.auth();
export const db = mangaa.firestore();
export const famdyauth = famdy.auth();
export const famdydb = famdy.firestore();
